"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StovesHousesNamibiaCal = void 0;
const calculator_1 = require("../calculator");
class StovesHousesNamibiaCal {
    static calculate(req) {
        const constants = req.stovesHousesNamibiaConstants;
        return Number((constants.emissionFactor * req.numberOfDays * req.numberOfPeopleInHousehold).toFixed(calculator_1.PRECISION));
    }
}
exports.StovesHousesNamibiaCal = StovesHousesNamibiaCal;
